import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createSlots as _createSlots, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Allowance Summary")
  ])
], -1)
const _hoisted_2 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top pt-7 p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "row col-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "select-tranche"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "select-entity"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, " Training Partner: ", -1)
const _hoisted_13 = {
  key: 2,
  class: "select-institute"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, " Institute : ", -1)
const _hoisted_15 = {
  key: 3,
  class: "select-type"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, " Training Course : ", -1)
const _hoisted_17 = {
  key: 4,
  class: "select-type"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, " Batch No : ", -1)
const _hoisted_19 = { class: "row col-12" }
const _hoisted_20 = { class: "col-4 mt-10" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "card mb-5 mb-xl-2" }
const _hoisted_23 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tranche",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_24 = { class: "card-title m-0" }
const _hoisted_25 = { class: "text-dark m-0 required" }
const _hoisted_26 = {
  id: "tranche",
  class: "collapse"
}
const _hoisted_27 = { class: "collapse show" }
const _hoisted_28 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_29 = { class: "row mt-3" }
const _hoisted_30 = { class: "col-md-12 dynamic-search" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "card mb-5 mb-xl-2" }
const _hoisted_33 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#test",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_34 = { class: "card-title m-0" }
const _hoisted_35 = { class: "text-dark m-0 required" }
const _hoisted_36 = {
  id: "test",
  class: "collapse"
}
const _hoisted_37 = { class: "collapse show" }
const _hoisted_38 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_39 = { class: "row mt-3" }
const _hoisted_40 = { class: "card mb-5 mb-xl-2" }
const _hoisted_41 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tinstitute",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_42 = { class: "card-title m-0" }
const _hoisted_43 = { class: "text-dark m-0" }
const _hoisted_44 = {
  id: "tinstitute",
  class: "collapse"
}
const _hoisted_45 = { class: "collapse show" }
const _hoisted_46 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_47 = { class: "row mt-3" }
const _hoisted_48 = { class: "card mb-5 mb-xl-2" }
const _hoisted_49 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course-data",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_50 = { class: "card-title m-0" }
const _hoisted_51 = { class: "text-dark m-0" }
const _hoisted_52 = {
  id: "course-data",
  class: "collapse"
}
const _hoisted_53 = { class: "collapse show" }
const _hoisted_54 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_55 = { class: "row mt-3" }
const _hoisted_56 = { class: "card mb-5 mb-xl-2" }
const _hoisted_57 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course-list",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_58 = { class: "card-title m-0" }
const _hoisted_59 = { class: "text-dark m-0" }
const _hoisted_60 = {
  id: "course-list",
  class: "collapse"
}
const _hoisted_61 = { class: "collapse show" }
const _hoisted_62 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_63 = { class: "row mt-3" }
const _hoisted_64 = { class: "col-md-12" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-restore-alt" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_67 = { class: "col-8" }
const _hoisted_68 = { class: "col-md-12 mt-1" }
const _hoisted_69 = { class: "row d-flex" }
const _hoisted_70 = { class: "col-md-5" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h3", null, "Select Header", -1)
const _hoisted_72 = { class: "card mb-5 mb-xl-2" }
const _hoisted_73 = {
  class: "card-header border-0 cursor-pointer accordion-button bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#header",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_74 = { class: "card-title m-0" }
const _hoisted_75 = { class: "text-dark m-0" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  id: "header",
  class: "collapse"
}
const _hoisted_78 = { class: "collapse show" }
const _hoisted_79 = {
  class: "card-body border-top p-9",
  style: {"overflow":"scroll","max-height":"28vh"}
}
const _hoisted_80 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_81 = { class: "row" }
const _hoisted_82 = ["name", "onUpdate:modelValue", "value"]
const _hoisted_83 = ["for"]
const _hoisted_84 = { class: "col-md-5 mt-8" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_86 = {
  key: 0,
  class: "col-md-12 mt-4"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h3", null, "Selected Headers", -1)
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = ["onUpdate:modelValue"]
const _hoisted_91 = { class: "row col-12" }
const _hoisted_92 = {
  key: 0,
  class: "row mt-1 w-100 m-0"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_94 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = {
  key: 1,
  class: "row"
}
const _hoisted_102 = {
  class: "col-md-12 mt-4",
  id: "dataTable"
}
const _hoisted_103 = { class: "row" }
const _hoisted_104 = {
  class: "current",
  "data-kt-stepper-element": "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[16] || (_cache[16] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "card mb-5 mb-xl-10",
        key: _ctx.componentKey
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", null, [
                    _createTextVNode(" Showing data for: "),
                    (
                    !_ctx.TpartnerLabel &&
                    !_ctx.TranceLabel &&
                    !_ctx.TinstituteLabel &&
                    !_ctx.TbatchLabel &&
                    !_ctx.TcourseLabel
                  )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " All "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                          (_ctx.TranceLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                _hoisted_10,
                                _createTextVNode(" " + _toDisplayString(_ctx.TranceLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TpartnerLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _hoisted_12,
                                _createTextVNode(" " + _toDisplayString(_ctx.TpartnerLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TinstituteLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                _hoisted_14,
                                _createTextVNode(" " + _toDisplayString(_ctx.TinstituteLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TcourseLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(_ctx.TcourseLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TbatchLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                _hoisted_18,
                                _createTextVNode(" " + _toDisplayString(_ctx.TbatchLabel), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("label", _hoisted_25, [
                              _createElementVNode("span", null, _toDisplayString(this.tranches.length) + " Phase", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Phase",
                                modelValue: _ctx.TranceData,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.TranceData) = $event)),
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trancheLabelChange(_ctx.TranceData)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: trans.id,
                                      label: trans.label,
                                      value: trans.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(trans.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("label", _hoisted_35, [
                                  _createElementVNode("span", null, _toDisplayString(this.associations.length) + " Training Partner", 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select Partner",
                                    modelValue: _ctx.TpartnerData,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.TpartnerData) = $event)),
                                    filterable: "",
                                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trainingInstitute(_ctx.TpartnerData))),
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: assoc.id,
                                          label: assoc.entity_short_name,
                                          value: assoc.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("label", _hoisted_43, [
                                  _createElementVNode("span", null, _toDisplayString(this.institutes.length) + " Training Institute", 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    placeholder: "Select Institute",
                                    modelValue: _ctx.Tinstitute,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.Tinstitute) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getCourseList(_ctx.Tinstitute)))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: inst.id,
                                          label: inst.institute_name,
                                          value: inst.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(inst.institute_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("label", _hoisted_51, [
                                  _createElementVNode("span", null, _toDisplayString(this.courses.length) + " Course ", 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    "collapse-tags": "",
                                    placeholder: "Select Course",
                                    modelValue: _ctx.TcourseData,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.TcourseData) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getBatchList(_ctx.TcourseData)))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: course.id,
                                          label: course.course_name,
                                          value: course.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(course.course_name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("label", _hoisted_59, [
                                  _createElementVNode("span", null, _toDisplayString(this.batches.length) + " Batch ", 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                  _createVNode(_component_el_select, {
                                    class: "form-select-solid",
                                    "collapse-tags": "",
                                    placeholder: "Select Batch",
                                    modelValue: _ctx.TbatchData,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.TbatchData) = $event)),
                                    filterable: "",
                                    style: {"width":"100%"},
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.batchLabel(_ctx.TbatchData)))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: batch.id,
                                          label: batch.batch_number,
                                          value: batch.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(batch.batch_number), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("button", {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resetData())),
                              type: "button",
                              class: "btn btn-danger p-3 mr-4",
                              style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                            }, [
                              _createTextVNode(" Reset "),
                              _hoisted_65
                            ]),
                            _createElementVNode("button", {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.generateAttendanceReport())),
                              type: "button",
                              class: "btn btn-success p-3",
                              style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                            }, [
                              _createTextVNode(" Search "),
                              _hoisted_66
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("label", _hoisted_75, [
                                  (_ctx.headerSelect)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.st.length) + " Selected", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("div", _hoisted_81, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (info) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "form-check",
                                          key: info.key
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            multiple: "",
                                            name: info.name,
                                            "onUpdate:modelValue": ($event: any) => ((info.selected) = $event),
                                            value: {
                                        name: info.name,
                                        key: info.key,
                                      },
                                            class: "form-check-input"
                                          }, null, 8, _hoisted_82), [
                                            [_vModelCheckbox, info.selected]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "form-check-label",
                                            for: info.name
                                          }, _toDisplayString(info.name), 9, _hoisted_83)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("button", {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.generateAttendanceReport())),
                            type: "button",
                            class: "btn btn-success p-3 mr-4",
                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                          }, [
                            _createTextVNode(" Search "),
                            _hoisted_85
                          ])
                        ]),
                        (_ctx.showall)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              _hoisted_87,
                              (_ctx.st.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                    _createElementVNode("div", _hoisted_89, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.st, (data, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "col-md-3",
                                          key: index
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "btn btn-primary m-1 py-2 px-2 w-100",
                                            "onUpdate:modelValue": ($event: any) => ((data.name) = $event)
                                          }, null, 8, _hoisted_90), [
                                            [_vModelText, data.name]
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  (_ctx.showTableData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                            title: "Download Xlse",
                            "data-v-54b12dc8": "",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.exportTrainee()))
                          }, _hoisted_96),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Download PDF",
                            "data-v-54b12dc8": "",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.downloadPdf()))
                          }, _hoisted_98),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Print",
                            "data-v-54b12dc8": "",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.printPdf()))
                          }, _hoisted_100)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showTableData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            (_openBlock(), _createElementBlock("div", {
                              key: _ctx.componentTableKey,
                              class: "card-body p-6",
                              "data-v-71816626": "",
                              style: {"border-radius":"1em","border":"2px solid #8dcb8d"}
                            }, [
                              _createElementVNode("div", _hoisted_104, [
                                _createVNode(_component_Datatable, {
                                  "table-data": _ctx.tableData,
                                  "table-header": _ctx.st,
                                  "enable-items-per-page-dropdown": true
                                }, _createSlots({
                                  "cell-name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.trainee_name), 1)
                                  ]),
                                  "cell-reg_no": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.registration_number), 1)
                                  ]),
                                  "cell-fName": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.father_name), 1)
                                  ]),
                                  "cell-mName": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.mother_name), 1)
                                  ]),
                                  "cell-number": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.mobile), 1)
                                  ]),
                                  "cell-institute_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.institute_info
                                  ?.institute_name), 1)
                                  ]),
                                  "cell-course_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.course_info?.course_name), 1)
                                  ]),
                                  "cell-batch_number": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.batch_info?.batch_number), 1)
                                  ]),
                                  "cell-bill": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.trainee_batch_bill_info?.bill_no), 1)
                                  ]),
                                  "cell-total_class": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.course_info?.session), 1)
                                  ]),
                                  "cell-present": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.present), 1)
                                  ]),
                                  "cell-absent": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.absent), 1)
                                  ]),
                                  "cell-percentage": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.attendance_percentage), 1)
                                  ]),
                                  "cell-dropOut": _withCtx(({ row: industry }) => [
                                    (industry?.trainee?.training_assessment?.assessment_score == 0)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" Absent ")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(industry?.trainee?.attendance_percentage >= 80
                                  ? 'No'
                                  : 'Yes'), 1)
                                        ], 64))
                                  ]),
                                  "cell-bank_account": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.bank_account_number), 1)
                                  ]),
                                  "cell-account_type": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.account_type), 1)
                                  ]),
                                  "cell-bank_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.bank_name), 1)
                                  ]),
                                  "cell-branche_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee?.bank_branch_name), 1)
                                  ]),
                                  _: 2
                                }, [
                                  (_ctx.term1complete)
                                    ? {
                                        name: "cell-term_1_completed",
                                        fn: _withCtx(({ row: industry }) => [
                                          _createTextVNode(_toDisplayString(industry?.term1_class_completed), 1)
                                        ]),
                                        key: "0"
                                      }
                                    : undefined,
                                  (_ctx.term2complete)
                                    ? {
                                        name: "cell-term_2_completed",
                                        fn: _withCtx(({ row: industry }) => [
                                          _createTextVNode(_toDisplayString(industry?.term2_class_completed), 1)
                                        ]),
                                        key: "1"
                                      }
                                    : undefined,
                                  (_ctx.term3complete)
                                    ? {
                                        name: "cell-term_3_completed",
                                        fn: _withCtx(({ row: industry }) => [
                                          _createTextVNode(_toDisplayString(industry?.term3_class_completed), 1)
                                        ]),
                                        key: "2"
                                      }
                                    : undefined
                                ]), 1032, ["table-data", "table-header"])
                              ])
                            ]))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}